import { ExpensesEntitiesExpensableResourceTypeEnum } from 'generated/resources/graphql'
import { z } from 'zod'

import { AdditionalInformationSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/AdditionalInformation/form/schema'
import { EffectiveOnFieldSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/BasicInformation/form/EffectiveOnField/schema'
import { OwnerFieldSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/BasicInformation/form/OwnerField/schema'
import { BudgetSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/Budget/form/schema'
import {
  CategorySchema,
  superRefineCategorySchema,
} from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/Category/form/schema'
import { CostCenterSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/CostCenters/form/schema'
import { GroupSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/Group/form/schema'
import { ProjectsSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/Projects/form/schema'
import { MileageInformationSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/mileage/MileageInformation/form/schema'
import { RoundTripSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/mileage/RoundTrip/form/schema'
import { TripInformationSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/mileage/Trip/form/schema'
import { FilesSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Files/form/schema'
import { CustomizationField } from 'modules/expenses/hooks/useExpensesCustomization'
import { ProjectWorker } from 'modules/expenses/hooks/useProjects'
import { BudgetOption } from 'modules/finance/hooks/useBudgets'

interface FormContext {
  customizationFields: CustomizationField[]
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
  budgetOptions: BudgetOption[]
  projectWorkers: ProjectWorker[]
  hasProjectsFeature: boolean
}
export const MileageSchema = ({
  customizationFields,
  resourceType,
  budgetOptions,
  projectWorkers,
  hasProjectsFeature,
}: FormContext) => {
  return z
    .object({
      ...OwnerFieldSchema().shape,
      ...CategorySchema().shape,
      ...EffectiveOnFieldSchema({
        customizationFields,
        resourceType,
      }).shape,
      ...AdditionalInformationSchema({
        customizationFields,
        resourceType,
      }).shape,
      ...BudgetSchema({
        customizationFields,
        budgetOptions,
        resourceType,
      }).shape,
      ...ProjectsSchema({
        customizationFields,
        projectWorkers,
        hasProjectsFeature,
        resourceType,
      }).shape,
      ...FilesSchema({
        customizationFields,
        resourceType,
      }).shape,
      ...CostCenterSchema({ customizationFields, resourceType }).shape,
      ...TripInformationSchema({
        customizationFields,
        resourceType,
      }).shape,
      ...RoundTripSchema().shape,
      ...GroupSchema().shape,
      ...MileageInformationSchema().shape,
    })
    .superRefine((data, ctx) => {
      superRefineCategorySchema({
        data,
        ctx,
        customizationFields,
        resourceType,
      })
    })
}

export type MileageSchema = z.infer<ReturnType<typeof MileageSchema>>
